/*
 * @Descripttion: 
 * @version: 
 * @Author: yanghui
 * @Date: 2021-10-22 10:00:12
 * @LastEditors: yanghui
 * @LastEditTime: 2021-10-22 14:31:40
 */
import axios from "../../utils/axios";

// 礼品分类管理
export function getList(query) {
    return axios({
        url: "/hfIntegralGiftCatalogManage/getIntegralGiftCatalogList",
        method: "get",
        params: query
    });
}
//分类删除
export function deleteClassify(query) {
    return axios({
        url: "/hfIntegralGiftCatalogManage/delete",
        method: "delete",
        params: query
    });
}
// 分类增加
export function addClassify(data) {
    return axios({
        url: "/hfIntegralGiftCatalogManage/add",
        method: "post",
        data: data
    });
}

// 分类修改
export function updateClassify(data) {
    return axios({
        url: "/hfIntegralGiftCatalogManage/update",
        method: "put",
        data: data
    });
}


//礼品下的所有分类
export function getGiftCatalogListApi(query) {
  return axios({
      url: "/hfIntegralGiftCatalogManage/getGiftCatalogList",
      method: "get",
      params: query
  });
}
